"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThunderCallersStrikeAbilityHandler = exports.ThunderCallersStrikeActorAbilityFactory = exports.ThunderCallersStrikeAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const __1 = require("../..");
const Damage_1 = require("../../core/Damage");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const core_1 = require("../../core/vfx/core");
const IdArray_1 = require("../../core/utils/IdArray");
const EffectType_1 = require("../../core/effects/EffectType");
const core_2 = require("../../core/effects/core");
const Duration_1 = require("../../core/Duration");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class ThunderCallersStrikeAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.ThunderCallersStrike;
        this.__typeName = "ThunderCallersStrike";
    }
}
exports.ThunderCallersStrikeAbilityArgs = ThunderCallersStrikeAbilityArgs;
let ThunderCallersStrikeActorAbilityFactory = class ThunderCallersStrikeActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("ThunderCallersStrike", "AllEnemies", 3);
    }
};
ThunderCallersStrikeActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("ThunderCallersStrike")
], ThunderCallersStrikeActorAbilityFactory);
exports.ThunderCallersStrikeActorAbilityFactory = ThunderCallersStrikeActorAbilityFactory;
let ThunderCallersStrikeAbilityHandler = class ThunderCallersStrikeAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const randomEnemyOrder = (0, IdArray_1.shuffle)(container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies));
        container.applyJumpingProjectileAttackWithDamage({
            sequence,
            attackerId: ability.invokerId,
            targetIds: randomEnemyOrder,
            attackType: "magic",
            abilityKey: ability.args.__typeName,
            projectileType: "BlueCometElectrified",
            projectilePath: "line",
            toApply: [
                AbilityDamage_1.AbilityDamage.Focus("Sonic", 150)
            ],
            onHit: (sequence, attack, damages, targetId) => {
                sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(targetId, "chest"), "FaintFire"));
                if (container.hasEffectOfType(targetId, EffectType_1.EffectType.Convulsions)) {
                    const amountDealt = Damage_1.Damage.Sum(damages);
                    container.applyExactDamage({
                        sequence,
                        targetId,
                        attackerId: ability.invokerId,
                        damage: new Damage_1.Damage(__1.DamageType.Sonic, Math.round(amountDealt * .2))
                    });
                    container.applyDebuff({
                        attackerId: ability.invokerId,
                        targetId,
                        effect: new core_2.ConvulsionsEffectArgs("Focus", 10),
                        duration: Duration_1.Duration.Ticks(8),
                        sequence: sequence
                    });
                }
            },
        });
    }
};
ThunderCallersStrikeAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.ThunderCallersStrike)
], ThunderCallersStrikeAbilityHandler);
exports.ThunderCallersStrikeAbilityHandler = ThunderCallersStrikeAbilityHandler;
